import {
	AfterViewInit,
	Component,
	ElementRef,
	OnInit,
	Renderer2,
} from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { AppModalService } from '@datachain/ui-sdk/components/app-modal';
import { IBreadCrumbEntry } from '@datachain/ui-sdk/components/breadcrumb';
import { Store } from '@ngrx/store';
import { Observable, takeUntil, tap } from 'rxjs';

import { ResizeProvider } from '../../../core/app-resize-wrapper/resize-provider';
import { ProjectStorage } from '../../../core/services/project.storage';
import { goToHdHome, goToProjects } from '../../../core/store';
import { DcIcons } from '../../../ui/app-dc.icons';
import {
	getSwitchableConsumedProjects,
	navigateToSubscriptionCreate,
	SubscriptionSelector,
} from '../../store';
import { VersionSwitcherModalComponent } from '../version-switcher-modal/version-switcher-modal.component';
import { SubscriptionViewProvider } from './subscription-view.provider';

@Component({
	selector: 'app-subscription-list-standalone',
	templateUrl: './subscription-list-standalone.component.html',
	styleUrls: ['./subscription-list-standalone.component.scss'],
	inputs: ['projectLabel'],
	providers: [SubscriptionViewProvider],
})
export class SubscriptionListStandaloneComponent
	extends DcBaseComponent
	implements OnInit, AfterViewInit
{
	protected readonly DcIcons = DcIcons;

	public paths: Array<IBreadCrumbEntry> = [];

	public vo$: Observable<{
		hasCreatePermission: boolean;
		projectVersionCount: number;
	}>;

	public constructor(
		private readonly store: Store,
		private readonly modalService: AppModalService,
		private readonly subscriptionViewProvider: SubscriptionViewProvider,
		private readonly selector: SubscriptionSelector,
		private readonly resizeProvider: ResizeProvider,
		private readonly renderer: Renderer2,
		private readonly elemRef: ElementRef,
		private readonly projectStorage: ProjectStorage
	) {
		super();
		this.cmpId = 'subscription-list-standalone';

		this.vo$ = combineAll({
			hasCreatePermission: this.selector.getHasCreatePermission$(),
			projectVersionCount: this.projectStorage.getProjectVersionCount(),
		});
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.triggerInit();
	}

	public override ngAfterViewInit(): void {
		super.ngAfterViewInit();
		setTimeout(() => {
			this.subscriptionViewProvider.adjustHeights(this.elemRef, this.renderer);
		}, 500);
	}

	public openSwitchableConsumedProjectsModal(): void {
		this.store.dispatch(getSwitchableConsumedProjects());
		this.modalService.openModal<{
			inViewMode: boolean;
		}>(
			VersionSwitcherModalComponent,
			{
				title: $localize`:i18n=@@subscription.versionSwitcher.modal.header:`,
				subTitle: '',
				inViewMode: false,
			},
			{
				disableClose: true,
			}
		);
	}

	public createNew(): void {
		this.store.dispatch(navigateToSubscriptionCreate());
	}

	private triggerInit(): void {
		this.resizeProvider.data$
			.pipe(
				takeUntil(this.onDestroy$),
				tap(() =>
					this.subscriptionViewProvider.adjustHeights(
						this.elemRef,
						this.renderer
					)
				)
			)
			.subscribe();

		this.toObservable<string>('projectLabel')
			.pipe(
				takeUntil(this.onDestroy$),
				tap((projectLabel) => {
					this.paths = [
						{
							label: $localize`:i18n=@@general.projects:`,
							isActive: true,
							callback: (): void => this.store.dispatch(goToProjects()),
						},
						{
							label: projectLabel,
							isActive: true,
							callback: (): void => this.store.dispatch(goToHdHome()),
						},
						{
							label: $localize`:i18n=@@subscription.list.title:`,
							isActive: false,
							callback: (): void => {},
						},
					];
				})
			)
			.subscribe();
	}
}
